module.exports = __webpack_public_path__ + "static/media/BI.e1232b93.png";